export const DEFAULT_LINE_COUNT = 2;
export const DEFAULT_FALLBACK_MAX_HEIGHT = 40;

export const BANNER_NOTIFICATION_KEY = 'BANNER_NOTIFICATION';
export const BANNER_ACTION_MORE_KEY = 'BANNER_ACTION_MORE';
export const BANNER_TYPE_NOTIFICATION_KEY = 'BANNER_TYPE_NOTIFICATION';
export const BANNER_TYPE_INFO_KEY = 'BANNER_TYPE_INFO';
export const BANNER_TYPE_DISTURBANCE_KEY = 'BANNER_TYPE_DISTURBANCE';
export const BANNER_TYPE_TRAFFIC_INFO_KEY = 'BANNER_TYPE_TRAFFIC_INFO';
export const BANNER_TYPE_WARNING_KEY = 'BANNER_TYPE_WARNING';
